import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {SignUpResendToken, SignUpResendTokenParams} from 'domain/usecases';

export class RemoteSignUpResendToken implements SignUpResendToken {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async resendToken(params: SignUpResendTokenParams): Promise<void> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
